<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="terms-of-service">
      <Title jpn="利用規約" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">株式会社ゼロプレイス（以下「当社」といいます。）が提供する本サイトにおいて提供するサービス（以下「本件サービス」といいます。）に関する条件及び当社とサービス利用者との権利義務関係について、以下のとおりサイト利用規約（その他の当社が契約の内容として別に定めるものを含みます。以下「本件規約」といいます。）として定めます。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第1条（用語の定義）</span>
            <span class="text">本件規約における以下の各号の用語の意味は、当該各号に定めるとおりとします。</span>
            <span class="text">(1)「当社」とは、本サービスを提供する株式会社ゼロプレイスのことをいいます。</span>
            <span class="text">(2)「本サイト」とは、当社が提供するサイト
              <a href="https://gtchaxonline.com/" target="_blank">https://gtchaxonline.com/</a>
              のことをいいます。</span>
            <span class="text">(3)「本規約」とは、サービス利用者が遵守すべき規定のことをいいます。</span>
            <span class="text">(4)「サービス利用契約」とは、本件サービスの利用に関する契約をいいます。</span>
            <span class="text">(5)「サービス利用者」とは、当社とサービス利用契約を締結した者をいいます。</span>
            <span class="text">(6)「アカウント」とは、サービス利用者が本件サービスに登録したサービス利用者に関する情報をいいます。</span>
            <span class="text">(7)「パスワード」とは、お客様自身で作成した英数字の組み合わせで構成される暗号をいいます。</span>
            <span class="text">(8)「メールアドレス」とは、サービス利用者が本サービスにご登録いただいたメールアドレスをいいます。</span>
            <span class="text">(9)「Coin」とは、本サイト内で使う事が出来る仮想通貨をいいます。</span>
            <span class="text">(10)「商品」とは、本サイト内のゲームで獲得できるカードを示します。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第2条（適用範囲）</span>
            <span class="text">1 サービス利用者は、本規約の定めに従って本サイトを使用しなければならず、本規約に同意しない限り本サイトを利用できません。</span>
            <span class="text">2 サービス利用者が、本サイトの登録画面において、本規約への同意手続を行った時点で、サービス利用者と当社との間で、本規約の諸規定に従った利用契約（以下「本利用契約」といいます。）が成立し、本規約の内容がサービス利用者と当社との間の契約内容となります。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第3条（本件サービスの内容等）</span>
            <span class="text">1 本件サービスの内容・利用手順は、ご利用ガイドに記載のとおりです。</span>
            <span class="text">2 当社は、自らの判断により、随時本件サービスの内容を変更または提供を終了することができます。</span>
            <span class="text">3 サービス利用者は、当社による本件サービスの内容の変更もしくは提供の終了について異議を唱え、または損害賠償その他の請求を行うことはできません。</span>
            <span class="text">4 本件サービスの提供を終了する場合、当社の定める方法によって利用契約者に事前に通知するものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第4条（利用申込み）</span>
            <span class="text">1 本件サービスの利用を希望する場合は、本サイトにアクセスし、本件規約に同意の上、本件サービスの利用申込み（以下、本条において「サービス利用申込み」といいます。）を行うものとします。</span>
            <span class="text">2 サービス利用申込みに対し、当社が承諾することにより、当社とサービス利用申込みを行った方（以下、本条において「サービス利用申込者」といいます。）との間に、本件規約に基づくサービス利用契約が締結されます。</span>
            <span class="text">3 本サイトの利用希望者が未成年者等である場合、本サイトの利用に際し、事前に親権者等の法定代理人の同意を得るものとします。未成年者等が本規約に同意した場合は、法定代理人の同意を得たものとみなし、一切の責任は負いかねます。</span>
            <span class="text">4 当社は、サービス利用申込みを承諾しない場合があります。この場合において、当社は、その理由を開示する義務を負いません。</span>
            <span class="text">5 サービス利用申込者は、サービス利用申込みに際して不正確な情報または虚偽の情報を送信してはなりません。</span>
            <span class="text">6 アカウント情報の誤りまたは変更の遅延その他の不備により、本件サービスの利用に支障が生じた場合であっても、当社は当該支障について責任を負いません。</span>
            <span class="text">7 本規約及びCoin利用規約は、当社が企画開発し、運営提供する
              <a href="https://gtchaxonline.com/" target="_blank">https://gtchaxonline.com/</a>
              における、有料サービスをご利用いただく上で、当社とサービス利用者間における取り決めを定めるものです。</span>
            <span class="text">8 有料サービスを利用する全てのユーザーは本規約の取り決めを遵守する事とします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第5条（サービス利用者によるサービス利用契約の解約）</span>
            <span class="text">サービス利用者は、本件サービス上での解約手続きその他の当社が別途指定する解約手続きを行うことにより、いつでもサービス利用契約を解約することができます。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第6条（本件サービスの利用登録）</span>
            <span class="text">1 サービス利用者が本件サービスを利用するために必要な端末、通信機器、ソフトウェア、インターネットへの接続に関する契約等の準備は、サービス利用者が自己の費用と責任において準備しなければなりません。</span>
            <span class="text">2 当社は、サービス利用者による本件サービスの利用環境について一切関与せず、また一切の責任を負いません。</span>
            <span class="text">3 サービス利用者は、登録時にご自身のメールアドレスを登録することで、これを本件サービスにおけるメールアドレスとして利用出来ます。なお、サイト内でメールアドレスの変更はできかねますので誤ったメールアドレスで登録をした場合やメールアドレスの変更がある際は、本人確認をさせていただいた上で当社において変更をおこなわせていただきます。</span>
            <span class="text">4 サービス利用者は、原則としてお１人様１アカウントとし、複数アカウントの所持を禁止します。なお、当社は、サービス利用者の複数アカウントの所持が発覚した場合、事前の告知無く当該サービス利用者の所持するアカウントを削除します。この際、削除したアカウントに課金されているCoinは全て失効します。</span>
            <span class="text">5 本サイトの運営が困難であると当社が判断した場合、当該要因が解消されるまで、当社はサービス利用者に対し、本サービスの利用を制限する事が出来るものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第7条（アカウントの管理）</span>
            <span class="text">1 利用者は、利用に際して登録した情報（以下、「登録情報」といいます。メールアドレスやID・パスワード等を含みます）について、自己の責任の下に登録、管理するものとします。利用者は、これを第三者に利用させ、または貸与、譲渡、名義変更、売買などをしてはならないものとします。</span>
            <span class="text">2 当社は、登録情報によって本サービスの利用があった場合、利用登録をおこなった本人が利用したものと扱うことができ、当該利用によって生じた結果ならびにそれに伴う一切の責任については、利用登録を行った本人に帰属するものとします。</span>
            <span class="text">3 利用者は、登録情報の不正使用によって当社または第三者に損害が生じた場合、当社および第三者に対して、当該損害を賠償するものとします。</span>
            <span class="text">4 登録情報の管理は、利用者が自己の責任の下で行うものとし、登録情報が不正確または虚偽であったために利用者が被った一切の不利益および損害に関して、当社は責任を負わないものとします。</span>
            <span class="text">5 登録情報が盗用されまたは第三者に利用されていることが判明した場合、利用者は直ちにその旨を当社に通知するとともに、当社からの指示に従うものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第8条（サービス利用者の義務）</span>
            <span class="text">1 サービス利用者は、当社が別途明示的に許可した場合を除き、本件サービスに関し、以下の各号の行為を行ってはなりません。</span>
            <span class="text">(1) 法令に違反する行為</span>
            <span class="text">(2) 本件規約に違反する行為</span>
            <span class="text">(3) 当社または第三者に不当に不利益または損害を生じさせる行為</span>
            <span class="text">(4) 本件サービスの各機能の目的外利用</span>
            <span class="text">(5) 本件サービスを通常利用する際に用いられる方法とは異なる方法（自動化、スクレイピングを含みます。）による本件サービスの利用</span>
            <span class="text">(6) 当社または第三者の知的財産権侵害</span>
            <span class="text">(7) 当社または第三者に関するプライバシーもしくは肖像権の侵害</span>
            <span class="text">(8) 当社または第三者の秘密情報の漏洩</span>
            <span class="text">(9) 本件サービス内で閲覧できる情報の第三者提供</span>
            <span class="text">(10) 本人の同意を得ない第三者の個人情報の提供</span>
            <span class="text">(11) 当社または第三者に対する誹謗中傷</span>
            <span class="text">(12) 当社または第三者の名誉または信用の毀損</span>
            <span class="text">(13) 当社または第三者へのなりすまし</span>
            <span class="text">(14) 第三者のアカウント情報の利用</span>
            <span class="text">(15) 本件サービスの提供に用いられるシステムに記録された情報の改ざんまたは消去</span>
            <span class="text">(16) 有害なコンピュータプログラム等の送信、または当社もしくは第三者のリクエストに応じて送信可能な状態におくこと</span>
            <span class="text">(17) 他のサービス及び商品等並びに団体及び組織等の広告、宣伝または勧誘</span>
            <span class="text">(18) 本件サービスの提供その他の業務の妨害</span>
            <span class="text">(19) コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報の送信</span>
            <span class="text">(20) 本件サービスの提供に用いられている電気通信設備（サーバーを含みますがこれに限りません。以下、「電気通信設備」といいます。）に過度な負荷をかける行為</span>
            <span class="text">(21) 本件サービスの提供に用いられるシステムに設定されたアクセス制御機能の解除または回避その他の不正アクセス</span>
            <span class="text">(22) 本件サービスに用いられるソフトウェアの複製、修正、転載、改変、変更、リバースエンジニアリング、逆アセンブル、逆コンパイル、翻訳または解析</span>
            <span class="text">(23) 詐欺的な手段（いわゆるフィッシング及びこれに類する手段を含みます。）による当社または第三者からの情報の取得</span>
            <span class="text">(24) 当社に対する過度に長時間の架電、同様の問い合わせの過度の繰り返し、または義務や理由のない対応の強要</span>
            <span class="text">(25) 機器の販売、情報の提供、ハイパーリンクの設定等により上記各号のいずれかに該当する行為を助長する行為</span>
            <span class="text">(26) 上記各号のいずれかに該当するおそれがある行為</span>
            <span class="text">(27) その他当社が不適当(ご登録名義人名が不適切、アカウントの重複、お問合せの際のご発言内容等)と判断した行為</span>
            <span class="text">2 アカウント情報に変更が生じた場合、サービス利用者は遅滞なく当該変更後の情報を登録しなければなりません。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第9条（個人情報の取扱い）</span>
            <span class="text">サービス利用者は、当社が個人情報保護ポリシーの定めに従ってサービス利用者の個人情報を取り扱うことに同意します。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第10条（サービス利用者にかかる情報の削除）</span>
            <span class="text">1 当社は、サービス利用者とのサービス利用契約が解約された場合、当該サービス利用者にかかる情報（アカウント情報、アプリ内通貨及び有償サービスにかかる情報を含みますが、これに限りません。）を削除します。</span>
            <span class="text">2 当社は前項に基づき削除したサービス利用者にかかる情報の復元等は行いません。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第11条（サービスに関する権利）</span>
            <span class="text">当社より、本件サービスを通じてサービス利用者に提供されるコンテンツ及び情報等に関する知的財産権その他の権利は、当社または当社に権利を許諾している第三者に帰属します。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第12条（有料サービスについて）</span>
            <span class="text">1 サービス利用者は、当社所定の方法により、当社が本件サービス内又は当社の提供する他のサービスで提示している金額で当社の提供するサービス内でのみ使用可能なCoinを購入することができます。なお、当社は、サービス利用者に対して、Coinの購入について購入単位、決済方法、利用期間その他の購入条件を設けることがあり、設定した購入条件及び支払可能金額等は、本件サービス内に掲載します。</span>
            <span class="text">2 Coinの利用条件その他Coinの利用に関わる条件については、本規約の他、本サイト内に掲載するCoin利用規約の定めに従うものとします。</span>
            <span class="text">3 サービス利用者は、有料サービス利用料(その他有料サービスを通じてサービス利用者に債務が生じた場合はそれも含める)を、当社が別途定める支払い方法と条件に従い、支払うものとします。当社は、当社に過失があるなどの法的責任がある場合を除き、一度支払いを受けた当該料金について一切返金しないものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第13条（商品について）</span>
            <span class="text">1 サービス利用者は、有料サービスを利用して獲得した商品の配送を受けることが出来ます。</span>
            <span class="text">2 サービス利用者は、獲得した商品を、獲得時より24時間以内まで保有することができ、（以下、当該期間を「保有期間」といいます。）配送を希望する場合には、本サイトから所定の配送手続きをおこなわなければなりません。</span>
            <span class="text">3 前項の保有期間を過ぎた場合、サービス利用者はそれらの商品の配送を受ける権利を失うものとします。なお、保有期間を過ぎた商品につきましては自動的にCoinに返還するものとします。</span>
            <span class="text">4 当社は、サービス利用者の獲得した商品について、配送することが当社の責めに帰すべき事由により不能であることが明らかとなった場合には、当社は、サービス利用者が当該商品を取得するために使用したCoinをサービス利用者に対して付与することにより、その損害賠償責任を免れることとします。なお、当社は当該商品と同一の商品を取得し交付する義務を負わないものとします。</span>
            <span class="text">5 商品に関する配送料は全額当社負担といたします。なお、国外への配送については別途料金を徴収する場合がございます。</span>
            <span class="text">6 配送方法は当社提携先のヤマト運輸株式会社又は当社指定運送業者を利用いたします。</span>
            <span class="text">7 配送時期は、毎月5日・10日・15日・20日・25日・末日に、上記当社指定運送会社へ引き渡しをおこないます。</span>
            <span class="text">※上記配送時期前後のご利用の場合は、直近の配送時期ではなく、翌配送時期以降となることがございます。</span>
            <span class="text">※発送準備完了次第、発送通知をいたします。そのため、追跡番号がインターネット上に反映されることが翌日以降になることがございます。予めご容赦くださいませ。</span>
            <span class="text">8 商品発送中の破損などのトラブルが発生した場合、当社は一切の責任を負いかねます。</span>
            <span class="text">9 当社は、当該商品の配送までにサービス利用者の規約違反行為等が認められた場合には、商品の配送を停止することができるものとします。なお、これによる損害について当社は賠償する責任を負いません。</span>
            <span class="text">10 当社がサービス利用者に対して商品を配送した後、受け取り拒否、宛先不明等で返送され、当該サービス利用者が再送手続きをおこなわなかった場合には、当該サービス利用者は、当該商品に関する権利の一切を失うものとします。なお、この場合であっても、当社はCoinの返還義務等の一切の補償、損害賠償義務を負いません。</span>
            <span class="text">11.配送日等のお問い合わせにはご対応致しかねますこと、予めご容赦くださいませ。</span>
            <span class="text">12.本システムは商品名と還元Coinが結びついております。 万が一、画像が商品名と一致しない場合は、画像の商品の発送もしくは還元Coinではなく、 その商品名と還元Coinを優先させていただきます。予めご容赦ください。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第14条（クレジットカード等による利用）</span>
            <span class="text">1 本サイトにおいて、サービス利用者は、クレジットカードによる決済又は当社が提供する他のサービス内においては当該サービス内で定められた方法を利用することにより、Coinの購入をおこなうことができます。ただし、決済に利用するクレジットカードは、サービス利用者本人名義のものであり、かつ、決済時に有効なものに限られます。</span>
            <span class="text">2 サービス利用者は、クレジットカード決済を利用する場合、当該サービス利用者本人名義のクレジットカードに関する情報（クレジットカードの種類、カード番号及び有効期限等をいうものとし、以下、総称して「クレジットカード情報」といいます。）を当社指定の方法により登録するものとします。</span>
            <span class="text">3 クレジットカード情報の誤登録等によりサービス利用者に生じた損害について、当社は一切責任を負いません。また、クレジットカードの利用に関するサービス利用者の虚偽又は不正により当社が損害を被った場合、当該サービス利用者は当社に対して、当社の被った一切の損害を賠償するものとします。</span>
            <span class="text">4 当社は、本サイトの利用のために発生した料金についてのクレジットカードによる決済時において、所定の方法によりサービス利用者が決済に利用するクレジットカードについて、クレジットカード会社に支払い可否の承認を求めるものとし、その承認が得られない場合は、決済をしないものとすることができます。この場合、サービス利用者に損害が生じたときであっても、当社は当該損害について一切責任を負いません。</span>
            <span class="text">5 サービス利用者のクレジットカードによる決済が終了した後であっても、クレジットカード会社から当社に対し、当該クレジットカードの利用につき拒絶もしくは停止の通知がなされた場合またはクレジットカードの利用に関する当該サービス利用者の虚偽若しくは不正が判明した場合、当社はその理由のいかんを問わず、当該サービス利用者による全ての決済を中止できるものとします。</span>
            <span class="text">6 サービス利用者は、当社の提供する他のサービス内で本サービスに利用することができるCoinを購入することができますが、その場合には、本サービスと同一のアカウントにより購入をしなければならず、他のアカウントによりCoinを購入した場合には、本サービス内でCoinが反映されず、使用できないことを了承するものとします。なお、その場合には、当社は一切の返金等を行わず、一切の責任を負わないものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第15条（決済機関との関係等）</span>
            <span class="text">1 サービス利用者と本サービスのために当社が用いる課金決済会社又は決済代行会社との間で本サービスの料金その他の金銭債務を巡って紛争が生じた場合、当該サービス利用者と当該会社との間で解決するものとし、当社は、一切それに関与せず、一切の責任を負わないものとします。</span>
            <span class="text">2 前項の紛争がサービス利用者の責めに帰すべき事由により生じたものであって、これにより当社が損害を被った場合、当該サービス利用者は当社に対して当社の被った一切の損害を賠償するものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第16条（本件サービスの提供の停止等）</span>
            <span class="text">当社は、以下のいずれかの場合には、損害賠償その他の義務を負うことなく、一時的に本件サービスの全部または一部の提供を停止できるものとします。</span>
            <span class="text">(1) 本件サービスを提供するための設備の保守または点検等を行う場合</span>
            <span class="text">(2) 火災、停電等により本件サービスの提供に支障が生じた場合</span>
            <span class="text">(3) 地震、噴火、洪水、津波等の天災により本件サービスの提供に支障が生じた場合</span>
            <span class="text">(4) 戦争、動乱、暴動、騒乱、労働争議、感染症の蔓延、緊急事態宣言の発出等により本件サービスの提供に支障が生じた場合</span>
            <span class="text">(5) 本件サービスの運用上または技術上の理由により、当社が本件サービスの提供を一時的に延期または中断する必要があると判断した場合</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第17条（利用制限等）</span>
            <span class="text">1 当社は、サービス利用者が以下の各号のいずれかに該当すると判断した場合には、サービス利用者に事前に通知することなく、本件サービスの利用の停止、またはサービス利用契約の解約等の措置（以下、本条において「利用制限措置」といいます。）を講じることができるものとします。</span>
            <span class="text">(1) サービス利用者のパスワードが漏洩する事により、第三者が本サービスを不正利用した場合、当社の他のサービスを第三者が不正に利用した場合またはこれらの恐れのある場合。</span>
            <span class="text">(2) サービス利用者の行為によって当社の事業に支障をきたすと判断した場合。</span>
            <span class="text">(3) アカウントを複数取得した(禁止行為)場合。</span>
            <span class="text">(4) 本件規約に違反し、またはそのおそれがある場合。</span>
            <span class="text">(5) 前各号の他、利用制限措置を講じる必要があると当社が判断した場合。</span>
            <span class="text">2 当社が第１項に基づき利用制限措置を講じたことにより、サービス利用者に損害が発生した場合であっても、当社は当該損害について一切責任を負いません。</span>
            <span class="text">3 本条に基づきサービス利用契約が解約される場合、サービス利用者は当社に負っている債務について期限の利益を喪失し、ただちに当社に対してすべての債務を履行しなければなりません。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第18条（免責）</span>
            <span class="text">1 本件規約に特段の定めがない限り、当社は、サービス利用者に発生した損害を賠償せず、サービス利用者は当社に当該損害についての請求はできません。また、サービス利用者は、本件サービスの利用や利用の終了等により第三者に対し損害を与えた場合、自己の責任でこれを解決し、当社は責任を負担しません。ただし、当該損害が当社の故意または重過失によって生じた場合にはこの限りではありません。</span>
            <span class="text">2 当社は、天災地変、戦争、暴動、内乱、延焼による火災、洪水、法令の改廃制定、停電、公権力の介入、ストライキその他の労働争議、輸送機関の事故、感染症の蔓延、緊急事態宣言の発令その他当社の責に帰すべからざる事由より生じたサービス利用契約上の義務の不履行について、損害賠償責任その他一切の責任を負いません。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第19条（サービス利用者への通知）</span>
            <span class="text">サービス利用者は、当社からサービス利用者への通知が以下のいずれかの方法にて行われることに同意します。</span>
            <span class="text">(1) 本件サービス内に掲載して行います。この場合は、掲載された時をもってサービス利用者に対する通知が完了したものとみなします。</span>
            <span class="text">(2) 当社のWebサイト上に掲載して行います。この場合は、掲載された時をもってサービス利用者に対する通知が完了したものとみなします。</span>
            <span class="text">(3) サービス利用者が利用申込みの際またはその後に当社に届け出たサービス利用者の電子メールアドレス宛に電子メールを送信して行います。この場合は、サービス利用者の電子メールアドレス宛に電子メールを送信した時をもってサービス利用者に対する通知が完了したものとみなします。</span>
            <span class="text">(4) その他、当社が適切と判断する方法で行います。この場合は、当該通知の中で当社が指定した時をもってサービス利用者に対する通知が完了したものとみなします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第20条（反社会的勢力の排除）</span>
            <span class="text">サービス利用者は、次の各号について表明し、保証します。</span>
            <span class="text">(1) 過去または将来において、自らが反社会的勢力（暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、政治活動標ぼうゴロまたは特殊知能暴力集団等を含む。以下同じ。）ではないこと、反社会的勢力と取引きを行っていないこと、資金提供等の行為を通じて反社会的勢力の維持、運営に協力もしくは関与していないこと、その他反社会的勢力との意図的な交流がないこと</span>
            <span class="text">(2) 自らまたは第三者を利用して、当社または当社の従業員に対して、暴行・傷害・脅迫・恐喝・威圧等の暴力的もしくは脅迫的行為または風説の流布や偽計等の詐欺的手法を用いた要求、合理的な範囲を超える不当な要求、業務の妨害、名誉・信用の毀損等をおこなわないこと</span>
            <span class="text">(3) 自らが、反社会的勢力であること、または反社会的勢力と関係がある旨を、当社または第三者に伝える等の行為をしないこと</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第21条（サービス利用契約上の地位の移転等）</span>
            <span class="text">1 サービス利用者は、サービス利用契約上の地位またはサービス利用契約に関して有する権利もしくは義務について、第三者に譲渡、承継、売買、名義変更、担保設定等をすることはできません。</span>
            <span class="text">2 事業譲渡、会社分割、合併等の方法を問わず、当社が第三者に対して本件サービスにかかる事業の譲渡または承継（以下「事業譲渡等」といいます。）をする場合には、当社は当該事業譲渡等に伴い、サービス利用契約上の地位、サービス利用契約に基づく権利及び義務並びにアカウント情報を取り扱う権限を、サービス利用者の別段の同意を得ることなく当該事業譲渡等の譲受人に譲渡または承継することができるものとします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第22条（義務の存続）</span>
            <span class="text">サービス利用契約が終了した場合であっても、サービス利用者は、サービス利用契約の終了前に発生した義務を免れません。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第23条（本件件規約の変更）</span>
            <span class="text">1 当社は、以下の各号の場合には、サービス利用者の事前の承諾を得ることなく、本件規約を変更できるものとします。この場合、当社は、事前に変更後の利用規約をサービス利用者に通知します。</span>
            <span class="text">(1) 本件規約の変更内容がサービス利用者の一般の利益に適合する場合</span>
            <span class="text">(2) 本件利用規約の変更がサービス利用契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性、その他変更にかかる事情に照らして合理的である場合</span>
            <span class="text">2 当社は、前項に定める他、サービス利用者から本件利用規約の変更について同意を得ることにより、本件利用規約を変更できるものとします。</span>
            <span class="text">3 以下の各号の場合には、サービス利用者は、本件利用規約の変更に同意したものとみなします。</span>
            <span class="text">(1) 当社が変更の１ヶ月以上前にサービス利用者に対して本件利用規約の変更案及び本件利用規約の変更日を通知し、本件利用規約の変更日までにサービス利用者から当社に対し、書面により本件利用規約の変更に対する反対の意思表示がなされなかった場合</span>
            <span class="text">(2) 当社がサービス利用者に対して本件利用規約の変更案及び本件利用規約の変更日を通知し、かつサービス利用者が当該変更日以降に本件サービスを利用した場合</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第24条（裁判管轄）</span>
            <span class="text">本件規約またはサービス利用契約に関するサービス利用者と当社との間の訴訟については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">2025年2月28日 制定</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },
  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.terms-of-service{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: black;
  .terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .shadow-box {
        justify-content: left;
      }
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: black;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .terms-of-service {
    .scroll-container {
      .shadow-box-title-description {
        .text-container {
          span.text {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
